export default "__VITE_ASSET__D$dDnDCx__"